module.exports = __webpack_public_path__ + "static/media/mapa_kseg.33fcb6ac.png";